import { render, staticRenderFns } from "./scope_pentest.vue?vue&type=template&id=35f1617f&scoped=true"
import script from "./scope_pentest.vue?vue&type=script&lang=js"
export * from "./scope_pentest.vue?vue&type=script&lang=js"
import style0 from "./scope_pentest.vue?vue&type=style&index=0&id=35f1617f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f1617f",
  null
  
)

export default component.exports